import React from 'react';
import type { HouseType } from '../../types/house';
interface HouseTypeIconProps {
  type: HouseType;
  active: boolean;
}
function houseShape(x: number, w: number): string {
  const base = 34;
  const wall = 18;
  const roof = 11;
  return `M${x} ${base} V${base - wall} L${x + w / 2} ${base - wall - roof} L${x + w} ${base - wall} V${base} Z`;
}
export function HouseTypeIcon({
  type,
  active
}: HouseTypeIconProps) {
  const on = active ? 'fill-volt stroke-ink' : 'fill-canvas-deep stroke-ink';
  const off = 'fill-transparent stroke-ink/35';
  const common = {
    strokeWidth: 1.5,
    strokeLinejoin: 'round' as const
  };
  return <svg viewBox="0 0 56 36" className="h-10 w-16" aria-hidden="true" data-id="element-431" data-mp="17wdsge4fxlur">
      {type === 'vrijstaand' && <path d={houseShape(16, 24)} className={on} {...common} data-id="element-432" data-mp="1cuyv0k760hmd" />}
      {type === 'twee-onder-een-kap' && <>
          <path d={houseShape(6, 22)} className={on} {...common} data-id="element-433" data-mp="3sm38gugvrdp1" />
          <path d={houseShape(28, 22)} className={off} {...common} data-id="element-434" data-mp="1i4qxfxa0vcv" />
        </>}
      {(type === 'hoekwoning' || type === 'tussenwoning') && [3, 20, 37].map((x, i) => <path key={x} d={houseShape(x, 16)} className={(type === 'hoekwoning' ? i === 0 : i === 1) ? on : off} {...common} data-id="element-435" data-mp="2k93fvelvu2uz" data-mpi={i} />)}
      {type === 'appartement' && <>
          <rect x="15" y="3" width="26" height="31" rx="1.5" className={off} {...common} data-id="element-436" data-mp="2t7ow333vt5sl" />
          <rect x="19" y="14" width="8" height="7" rx="1" className={on} {...common} data-id="element-437" data-mp="377831skyib3b" />
        </>}
    </svg>;
}